import {
  DnDParentRenderer,
  getParentDnDProps,
} from '@design-system/components/dndList/DndList';
import { extrasVM } from '../Extras.page';
import { ExtrasItem } from './extras-item/extrasItem';
import { PropsWithChildren } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImages } from '@fortawesome/pro-regular-svg-icons';
import { toLegacyGuideURL } from '../viewModel/extras.mappers';

export const ExtrasItemRenderer: DnDParentRenderer<
  PropsWithChildren<{ id: string }>
> = ({ provided, item: { id } }) => {
  const vm = extrasVM.useValue();
  const content = vm.contentMap[id];

  if (!content) return null;

  const dndProps = getParentDnDProps(provided);

  switch (content.type) {
    case 'ContentLegacyGuide':
      return (
        <ExtrasItem
          type={content.type}
          title={content.value.title}
          description={[
            <span key="d">
              <FontAwesomeIcon icon={faImages} /> {content.value.count} slides
            </span>,
          ]}
          dndProps={dndProps}
          onToggleItem={() =>
            vm.dispatch('ToggleItemVisible', content.value.id)
          }
          imageURL={toLegacyGuideURL(content.value.contentId)}
          isPublished={content.value.isPublished}
          onEdit={() => vm.dispatch('Edit', content.value.id)}
          onDelete={() => vm.dispatch('Delete', content.value.id)}
        />
      );
    case 'ContentLink':
      return (
        <ExtrasItem
          type={content.type}
          imageURL={content.value.coverImage}
          title={content.value.title || 'Link'}
          description={[content.value.url]}
          dndProps={dndProps}
          onToggleItem={() =>
            vm.dispatch('ToggleItemVisible', content.value.id)
          }
          isPublished={content.value.isPublished}
          onEdit={() => vm.dispatch('Edit', content.value.id)}
          onDelete={() => vm.dispatch('Delete', content.value.id)}
        />
      );
    default:
      return null;
  }
};
